module.exports = __webpack_public_path__ + "img/address.d4a0e3f1.png";